import React from 'react'

import { useGlosseryDrawerContext } from '@guiker/glossery-drawer'
import { PhoneNumber } from '@guiker/phone-number-input'
import { Personal } from '@guiker/propsharing-shared'
import {
  DatePicker,
  FormSection,
  FormSection2,
  H3,
  TextField,
  ThreeColumnsGridLayout,
  useGetInputPropsWithUseT,
  useT,
} from '@guiker/react-framework'

import { SearchAddressComponent } from './SearchAddressComponent'
import { Title } from './Typography'

type AboutYouFormContentProps = {
  defaultValue?: Partial<Personal>
  readOnly?: boolean
  includeEmail?: boolean
}

export const AboutYouFormContent: React.FC<AboutYouFormContentProps> = ({
  defaultValue,
  readOnly,
  includeEmail = false,
}) => {
  const { tShared } = useT({ domain: 'legalProfile' })

  const inputProps = useGetInputPropsWithUseT<Personal>()({ t: tShared, defaultValue, readOnly })
  const { onOpen } = useGlosseryDrawerContext()

  return (
    <FormSection>
      <FormSection2
        title={<Title header={tShared('personalInfo.header')} onClick={onOpen} TitleComponent={H3} />}
        subtitle={tShared('personalInfo.description')}
      >
        <ThreeColumnsGridLayout>
          {includeEmail && <TextField {...inputProps('emailAddress')} readOnly={true} />}
          <TextField {...inputProps('legalName.firstName')} required />
          <TextField {...inputProps('legalName.middleName')} />
          <TextField {...inputProps('legalName.lastName')} required />
          <TextField {...inputProps('preferredName')} />
          <DatePicker {...inputProps('dateOfBirth')} disableFuture required />
          <PhoneNumber {...inputProps('phone')} disableFlags required />
        </ThreeColumnsGridLayout>
      </FormSection2>
      <FormSection2 title={tShared('currentAddress.header')}>
        <SearchAddressComponent />
      </FormSection2>
    </FormSection>
  )
}
